export default __webpack_public_path__ + "static/media/cost-icon.aa460f77.svg";